module.exports = __webpack_public_path__ + "img/cms-banner.49ebb934.png";